<div class="m-grid__item m-grid__item--fluid m-wrapper m-grid-responsive-lg" style="overflow: unset;">
  <ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
      <span class="chevron left"></span>
      <span class="chevron right"></span>
  </ngx-spinner>

  <!--MAIN-->
  <div *ngIf="form" class="m-content">
    <!--begin::Portlet-->
    <div class="row m-row">
      <div class="col-lg-8">
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">COUPONS</h3>
              </div>
          </div>
          </div>

          <!--begin::Form-->
          <form
            *ngIf="formLoaded"
            [formGroup]="form"
            class="m-form m-form--fit m-form--label-align-right"
          >
            <div class="m-portlet__body">
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  Title:
                </label>
                <div class="col-lg-8">
                  <input
                    type="text"
                    class="form-control m-input"
                    formControlName="couponTitle"
                    (focus)="couponTitleFocus = true; focusedControl = fieldDescriptions.couponTitle;"
                    (blur)="couponTitleFocus = false; focusedControl = null;"
                  />
                  <span class="m-form__help" style="color:darkgray;">
                    Appears at the top of the Google pay coupon.
                  </span>
                  <app-validation-display
                    [control]='form.controls.couponTitle'
                    errorMessage="The maximum title size must be less than 40"
                  ></app-validation-display>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label"> Description: </label>
                <div class="col-lg-8">
                  <textarea
                    type="text"
                    class="form-control m-input"
                    formControlName="offer"
                    (focus)="offerFocus = true; focusedControl = fieldDescriptions.offer"
                    (blur)="offerFocus = false; focusedControl = null;"
                  ></textarea>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label"> Company Name: </label>
                <div class="col-lg-8">
                  <input
                    type="text"
                    class="form-control m-input"
                    formControlName="provider"
                    (focus)="providerFocus = true; focusedControl = fieldDescriptions.provider;"
                    (blur)="providerFocus = false; focusedControl = null;"
                  />
                  <span class="m-form__help" style="color:darkgray;">
                    The company providing the coupon.
                  </span>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">Text color:</label>
                <div class="col-lg-8">
                  <input
                    formControlName="labelColor"
                    type="text"
                    class="form-control m-input"
                    placeholder="{{ form.controls.labelColor.value }}"
                    [colorPicker]="form.get('labelColor').value"
                    [cpAlphaChannel]="'disabled'"
                    [cpDisableInput]="true"
                    [value]="form.get('labelColor').value"
                    [style.background]="form.get('labelColor').value"
                    (colorPickerChange)="
                      form.get('labelColor').setValue($event)
                    "
                  />
                  <span class="m-form__help" style="color:darkgray;">
                    The color of all text on the coupon.
                  </span>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">Background color:</label>
                <div class="col-lg-8">
                  <input
                    formControlName="backgroundColor"
                    type="text"
                    class="form-control m-input"
                    placeholder="{{ form.controls.backgroundColor.value }}"
                    [colorPicker]="form.get('backgroundColor').value"
                    [cpAlphaChannel]="'disabled'"
                    [cpDisableInput]="true"
                    [value]="form.get('backgroundColor').value"
                    [style.background]="form.get('backgroundColor').value"
                    (colorPickerChange)="
                      form.get('backgroundColor').setValue($event)
                    "
                    (focus)="focusedControl = fieldDescriptions.backgroundColor;"
                    (blur)="focusedControl = null;"
                  />
                  <span class="m-form__help" style="color:darkgray;">
                    The background color of the coupon.
                  </span>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  Expiration Date:
                </label>
                <div class="col-lg-8">
                  <input
                    class="form-control m-input"
                    type="date"
                    formControlName="expire"
                    (focus)="expirationDateFocus = true; focusedControl = fieldDescriptions.expire;"
                    (blur)="expirationDateFocus = false; focusedControl = null;"
                  />
                  <app-validation-display
                    [control]="this.form.controls.expire"
                    errorMessage="Please enter a valid expiration date."
                  ></app-validation-display>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label" > Time Zone </label>
                <div class="col-lg-8" *ngIf="timeZones['us']">
                  <select
                    class="form-control m-input"
                    id="timeZones"
                    formControlName="timeZone"
                    [compareWith]="compare"
                    name="timeZones">
                    <option disabled value="0">--- Select Timezone ---</option>
                    <option *ngFor="let z of timeZones['us']" [ngValue]="z.Id">
                      {{z.DisplayName}}
                    </option>
                  </select>
                  <span class="m-form__help" style="color:darkgray;">
                    Coupons expire at 11:59 PM on the selected date in this time zone.
                  </span>
                  <app-validation-display
                    [control]="this.form.controls.timeZone"
                    errorMessage="Time zone is required."
                  ></app-validation-display>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label"></label>
                <div class="col-lg-8">
                    <span class="m-form__help" style="color:darkgray;">Images must be the exact size specified, otherwise they will be resized to the correct size</span>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label"> Icon Image: </label>
                <div
                  class="col-lg-8"
                  (click)="uploadIconFocus = true; focusedControl = fieldDescriptions.iconLarge;"
                  (mouseout)="uploadIconFocus = false; focusedControl = null;"
                >
                  <label for="file-3" class="frame1-bottom-image-container">

                    <input
                      type="file"
                      (change)="iconHandler($event.target.files)"
                      name="file-3[]"
                      id="file-3"
                      class="inputfile inputfile-3"
                      data-multiple-caption="{count} files selected"
                      accept="image/png"
                      (focus)="uploadIconFocus = true;"
                      (blur)="uploadIconFocus = false;"
                    />

                    <div class="d-flex flex-column" >
                      <img
                        [src]="form.get('iconLarge').value"
                        class="frame1-bottom-image"
                        height="58"
                        width="58"
                      />

                      <span class="m-form__help" >
                        Must be at least 58x58 pixels in size.
                      </span>
                    </div>
                  </label>
                  <app-validation-display
                    *ngIf="!coupon.id && !this.form.controls.iconSmall.value && !this.form.controls.iconSmall.errors?.incorrectFile; else validateIcon"
                    [control]="this.form.controls.iconSmall"
                    errorMessage="Please replace the default image."
                  ></app-validation-display>
                  <ng-template #validateIcon>
                    <app-validation-display
                      [control]="this.form.controls.iconSmall"
                      errorMessage="Please select a valid PNG file for the icon image."
                    ></app-validation-display>
                  </ng-template>
                </div>
              </div>
              <div class="form-group m-form__group row mt-0" >
                <label class="col-lg-4 col-form-label"> Logo Image: </label>
                <div
                  class="col-lg-8"
                  (click)="uploadLogoFocus = true; focusedControl = fieldDescriptions.logoLarge;"
                  (mouseout)="uploadLogoFocus = false; focusedControl = null;"
                >
                  <label for="file-1" class="frame1-bottom-image-container">
                    <input
                      type="file"
                      (change)="logoHandler($event.target.files)"
                      name="file-1[]"
                      id="file-1"
                      class="inputfile inputfile-3"
                      data-multiple-caption="{count} files selected"
                      accept="image/png"
                    />

                    <div class="d-flex flex-column mb-2">
                      <img
                      [src]="form.get('logoLarge').value"
                      class="frame1-bottom-image"
                      height="120"
                      width="280"
                      />
                      <span class="m-form__help">
                        Must have a width of at least 280px and a height of 120px.
                      </span>
                    </div>
                  </label>
                  <app-validation-display
                    *ngIf="!coupon.id && !this.form.controls.logoSmall.value && !this.form.controls.logoSmall.errors?.incorrectFile; else validateLogo"
                    [control]="this.form.controls.logoSmall"
                    errorMessage="Please replace the default image."
                  ></app-validation-display>
                  <ng-template #validateLogo>
                    <app-validation-display
                      [control]="this.form.controls.logoSmall"
                      errorMessage="Please select a valid PNG file for the logo image."
                    ></app-validation-display>
                  </ng-template>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label"> Main Image: </label>
                <div
                  class="col-lg-8"
                  (click)="uploadStripFocus = true; focusedControl = fieldDescriptions.stripLarge;"
                  (mouseout)="uploadStripFocus = false; focusedControl = null;"
                >
                  <label for="file-2" class="frame1-bottom-image-container">
                    <input
                      type="file"
                      (change)="stripHandler($event.target.files)"
                      name="file-2[]"
                      id="file-2"
                      class="inputfile inputfile-3"
                      data-multiple-caption="{count} files selected"
                      accept="image/png"
                    />
                    <div class="d-flex flex-column w-100">
                      <div class="width-100 position-relative" style="padding-top: 42.5%">
                        <div class="position-absolute" style="top: 0; left: 0;">
                          <img
                            [src]="form.get('stripLarge').value"
                            class="frame1-bottom-image"
                            height="246"
                            width="620"
                            style="height: 100%; width: 100%;"
                            alt="Strip Large"
                          />
                        </div>
                      </div>

                      <span class="m-form__help">
                        Must have a width of at least 620px and a height of 288px.
                      </span>
                    </div>
                  </label>
                  <app-validation-display
                    *ngIf="!coupon.id && !this.form.controls.stripSmall.value && !this.form.controls.stripSmall.errors?.incorrectFile; else validateStrip"
                    [control]="this.form.controls.stripSmall"
                    errorMessage="Please replace the default image."
                  ></app-validation-display>
                  <ng-template #validateStrip>
                    <app-validation-display
                      [control]="this.form.controls.stripSmall"
                      errorMessage="Please select a valid PNG file for the main image."
                    ></app-validation-display>
                  </ng-template>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  Barcode message:
                </label>
                <div class="col-lg-8">
                  <input
                    #barcodeMessage
                    type="text"
                    (keydown)="generate(form.get('barcodeType').value)"
                    class="form-control m-input"
                    formControlName="barcodeMessage"
                    (focus)="barcodeFocus = true; focusedControl = fieldDescriptions.barcodeMessage;"
                    (blur)="barcodeFocus = false; focusedControl = null;"
                  />
                  <span class="m-form__help">
                    The destination for the coupon. A website URL or coupon ID.
                  </span> <br>
                  <app-validation-display
                    [control]="form.controls.barcodeMessage"
                    errorMessage="Please enter a valid URL"
                  ></app-validation-display>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  Barcode format:
                </label>
                <div class="col-lg-8">
                  <ng-select
                    formControlName="barcodeType"
                    value="form.get.('barcodeType').value"
                    [searchable]="false"
                    [clearable]="false"
                    (change)="generate(form.get('barcodeType').value)"
                    (focus)="barcodeFocus = true; focusedControl = fieldDescriptions.barcodeType;"
                    (blur)="barcodeFocus = false; focusedControl = null;"
                  >
                    <ng-option
                      value="None"
                    >
                      No Barcode
                    </ng-option>
                    <ng-option
                      *ngFor="let elem of barcodeTypeList"
                      [value]="elem.key"
                      [default]
                    >
                      {{ elem.label }}
                    </ng-option>
                  </ng-select>
                  <span class="m-form__help">
                    Controls how the barcode appears on the coupon.
                  </span>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  Terms and Conditions:
                </label>
                <div class="col-lg-8">
                  <textarea
                    type="text"
                    class="form-control m-input"
                    style="height: 250px;"
                    formControlName="couponDisclaimer"
                  ></textarea>
                  <img
                    src="../../assets/app/media/img/icons/google-icon.png"
                    class="tooltip-icon"
                    style="position: relative; top: 5px"
                    tooltip="Used for Google Offers coupons"
                  />
                  <img
                    src="../../assets/app/media/img/icons/apple-icon.png"
                    class="tooltip-icon"
                    style="position: relative; top: 5px"
                    tooltip="Used for Apple coupons"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-4">
        <div
          class="m-portlet sticky"
          [style.paddingBottom]="!focusedControl && previewMode === 'Apple' ? '140%' :
                                  focusedControl && previewMode === 'Apple' ? '190%' :
                                  !focusedControl && previewMode === 'Google' ? '110%' :
                                  focusedControl && previewMode === 'Google' ? '190%' : '50%' "
        >
          <div class="sticky-inner">
          <div
            class="m-portlet__head"
            style="height: 6.25vw; max-height: 85px;"
          >
            <div class="m-portlet__head-caption d-flex h-100">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text coupon-preview-header">
                  Coupon preview
                </h3>
              </div>
              <div *ngIf="currentWindowWidth > 1275" class="preview-buttons">
                <button
                  type="button"
                  class="preview-mode-container"
                  style="margin-right: 5px;"
                  [style.border]="previewMode === 'Apple' ? '2px solid black' : ''"
                  (click)="previewMode = 'Apple';"
                >
                  <img
                    src="../../../assets/app/media/img/icons/apple-icon.png"
                    tooltip="Click here to see the Apple Wallet preview"
                  />
                </button>
                <button
                  type="button"
                  class="preview-mode-container"
                  [style.border]="previewMode === 'Google' ? '2px solid black' : ''"
                  (click)="previewMode = 'Google';"
                >
                  <img
                    src="../../../assets/app/media/img/icons/google-icon.png"
                    tooltip="Click here to see the Google Offer preview"
                  />
                </button>
              </div>
            </div>
          </div>
          <div
            *ngIf="previewMode === 'Apple' && currentWindowWidth > 1275"
            class="m-portlet__body coupon-body"
            [style.height]="!focusedControl ? '80%' : '59%' "
          >
            <div
              class="coupon-preview"
              [ngStyle]="{ background: form.get('backgroundColor').value }"
            >
              <div class="head">
                <img
                  [src]="form.get('logoLarge').value"
                  [class]="uploadLogoFocus ? 'highlighted logo-apple' : 'logo-apple'"
                />
                <div [class]="expirationDateFocus ? 'highlighted' : ''" style="margin: 2px; margin-right: 4%;">
                  <h3
                    [ngStyle]="{ color: form.get('labelColor').value }"
                    style="font-size: 0.75vw;">
                    EXPIRATION
                  </h3>
                  <small
                    [ngStyle]="{ color: form.get('labelColor').value }"
                    style="font-size: 1.2vw;">
                    {{ form.get("expire").value | date }}
                  </small>
                </div>
              </div>
              <div class="main">
                <img
                  [class]="uploadStripFocus ? 'highlighted mainBg' : 'mainBg'"
                  [src]="form.get('stripLarge').value"
                />
              </div>
              <div class="foot">
                <div [class]="offerFocus ? 'highlighted offer' : 'offer'">
                  <h3 [ngStyle]="{ color: form.get('labelColor').value }" style="font-size: 0.8vw;">
                    OFFER
                  </h3>
                  <small
                    [ngStyle]="{ color: form.get('labelColor').value }"
                    style="font-size: 0.75vw;"
                  >
                    {{ form.get("offer").value }}
                  </small>
                </div>
                <div
                  *ngIf="form.controls.barcodeType.value !== 'None'"
                  class="barcode-image"
                  [ngClass]="{
                    'expand-barcode-container':
                      form.get('barcodeType').value === 'pdf417'
                  }"
                  [class]="barcodeFocus ? 'highlighted' : ''"
                >
                  <img #barcodeImage [src]="imgUrl" id="barcodeImage" />
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="previewMode === 'Google' && currentWindowWidth > 1275"
            class="m-portlet__body"
            [style.height]="!focusedControl ? '80%' : '46%'"
          >
            <div
              class="coupon-preview-google"
              [ngStyle]="{ background: form.get('backgroundColor').value }"
            >
              <div class="head">
                <img
                  [src]="form.get('iconLarge').value"
                  [class]="uploadIconFocus ? 'highlighted' : ''"
                />
              </div>
              <div class="main">
                <div
                  [ngStyle]="{ color: form.get('labelColor').value }"
                  [class]="providerFocus ? 'highlighted provider' : 'provider'"
                >
                  {{ form.get("provider").value }}
                </div>
                <div class="offer">
                  <small
                    [ngStyle]="{ color: form.get('labelColor').value }"
                    [class]="offerFocus ? 'highlighted offer' : 'offer'"
                  >
                    {{ form.get("offer").value }}
                  </small>
                </div>
              </div>
              <div class="foot">
                <img [class]="uploadStripFocus ? 'highlighted mainBg' : 'mainBg'" [src]="form.get('stripLarge').value" />
              </div>
            </div>
          </div>

          <div
            *ngIf="currentWindowWidth < 1275"
            class="m-portlet__body"
          >
            <button
              (click)="openPreviewModal()"
              type="button"
              class="btn btn-success"
              style="width: 100%"
            >
              Open Preview
            </button>
          </div>

          <div *ngIf="focusedControl && previewMode !== 'Modal'" class="m-portlet__body">
            <label class="description-title">
              Field Description
            </label>
            <hr>
            <div style="font-size: 1vw;">
              {{ focusedControl }}
            </div>
          </div>
          </div>
        </div>
        <!--begin::Form-->
      </div>
    </div>
    <div class="d-flex align-items-center">
      <button
        *ngIf="coupon.id == null"
        [disabled]="!form.valid"
        (click)="createOrUpdateCoupon()"
        type="button"
        class="btn btn-primary"
      >
        Create
      </button>
      <button
        [disabled]="!form.valid"
        *ngIf="coupon.id != null"
        (click)="createOrUpdateCoupon()"
        type="button"
        class="btn btn-primary"
      >
        Update
      </button>
      <button (click)="cancel()" type="button" class="btn btn-danger  ml-3" >
        Cancel
      </button>
      <span class="m-form__help_error position-static ml-3" *ngIf="!form.valid && !coupon.id">Please replace the default images and complete the required coupon fields to continue</span>
      <span class="m-form__help_error position-static ml-3" *ngIf="!form.valid && coupon.id">Please complete the required coupon fields to continue</span>
    </div>
  </div>
</div>
